export type IValidationConstraint = string | number | boolean;
